<template>
	<div class="innerBox">
		<div class="row">
			<div class="col-md-8 col-8">
				<h2 class="mb-4">Pembayaran Work Order</h2>
			</div>
			<div class="col-md-4 col-4 text-right" v-if="backButton">
				<button class="btn btn-primary" @click="returnToPage">< Kembali</button>
			</div>
		</div>
		

		<div class="row row-space" v-if="searchWo">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 text-left">
				<div class="">
				<label class="label" style="text-align:left !important">ID Work Order<span style="color: red;">*</span></label>
				<MultiSelect
					class="w-100"
					v-if="woList"
					v-model="workorder_id"
					:options="woList.map(type => type.form_code)"
					:custom-label="opt => woList.find(x => x.form_code == opt).form_code + ' - ' + woList.find(x => x.form_code == opt).registration + ' - ' + woList.find(x => x.form_code == opt).car_name"
					:searchable="true"
					:close-on-select="true"
					:multiple="false"
					:allow-empty="false"
					placeholder="Pilih ID Work Order"
				></MultiSelect>
				</div>
			</div>
		</div>

		<!-- <hr v-if="searchWo"> -->

		<div v-if="workOrderDetail && totalCost" class="mt-3">

			<div class="row row-space ">
				<div class="col-md-3 col-6" >
					<h6 class="middle">Pembayaran Work Order Untuk : </h6>
				</div>
				<div class="col-3 col-md-3 row">
					<div class="col-4">
						<input type="radio" name="optradio" v-model="paymentType" value="OwnRisk" >
					</div>
					<div class="col-8 middle">
						<label class="radio-inline">Own Risk</label>
					</div>
					
				</div>
				<div class="col-3 col-md-3 row">
					<div class="col-4">
						<input type="radio" name="optradio" v-model="paymentType" value="Full" >
					</div>
					<div class="col-8 middle">
						<label class="radio-inline">Pembayaran Full</label>
					</div>
				</div>
				<!-- <div class="col-3 col-md-3 row">
					<div class="col-4">
						<input type="radio" name="optradio" v-model="paymentType" :disabled="listPayment && listPayment.find(x => x.work_order_payment_type_id == 2 || x.work_order_payment_type_id == 3)" value="DP" >
					</div>
					<div class="col-8 middle">
						<label class="radio-inline">DP Workorder</label>
					</div>
				</div> -->
			</div>

			<!-- <hr> -->
			<div class="row row-space mt-3 mb-4">
				<div class="col-md-3 col-4 middle" >
					<h6 class="middle">Opsi : </h6>
				</div>
				<div class="col-md-3 col-12" >
					<button
						type="button"
						class="btn btn-outline-info"
						style="width:200px;"
						@click="modal.printSuratPuas = true"
						:disabled="!woFull.customer_car"
					>Print Surat Puas</button>
				</div>
				<div class="col-md-3 col-12">
					<!-- <button
						type="button"
						class="btn btn-outline-info"
						style="width:200px;"
						@click="$router.push({ path:'/cso/exit-permit', query : { form_code : workorder_id } })"
					>Print Gate Pass</button> -->
					<button
						type="button"
						class="btn btn-outline-info"
						style="width:200px;"
						@click="sendToGatePass()"
						:disabled="!woFull.customer_car"
					>Print Gate Pass</button>
				</div>
				<div class="col-md-3 col-12">
					<!-- <button
						type="button"
						class="btn btn-outline-info"
						style="width:200px;"
						@click="$router.push({ path:'/cso/exit-permit', query : { form_code : workorder_id } })"
					>Print Gate Pass</button> -->
					<button
						type="button"
						class="btn btn-outline-info"
						style="width:200px;"
						@click="showPrintEpoxy(true)"
						:disabled="!woFull.customer_car"
					>Print Gambar Epoxy</button>
				</div>

			
			</div>

			<div class="row row-space mt-3 mb-3">
				<div class="col-md-6 col-12 mt-2">
					<h5>Status Pembayaran WO</h5>
					<table class="table table-bordered" >
						<thead class="thead-dark">
							<th>Tipe Pembayaran</th>
							<th>Waktu Terbayar</th>
							<th>Jumlah</th>
							<th>Discount</th>
							<th>Deskripsi</th>
						</thead>
						<tbody v-if="listPayment">
							<tr v-for="(payment, index) in paymentListType" :key="payment">
								<td>{{payment}}</td>
								<td>{{listPayment && listPayment.find(x => x.work_order_payment_type_id == index + 1) ? moment(listPayment.find(x => x.work_order_payment_type_id == index + 1).created_at).format("DD MMM Y HH:mm")  : '-'}}</td>
								<td>Rp. {{listPayment && listPayment.find(x => x.work_order_payment_type_id == index + 1) ? numberWithCommas(listPayment.find(x => x.work_order_payment_type_id == index + 1).amount)  : '-'}}</td>
								<td>Rp. {{listPayment && listPayment.find(x => x.work_order_payment_type_id == index + 1) ? numberWithCommas(listPayment.find(x => x.work_order_payment_type_id == index + 1).discount ? listPayment.find(x => x.work_order_payment_type_id == index + 1).discount : 0 )  : '-'}}</td>
								<td>{{listPayment && listPayment.find(x => x.work_order_payment_type_id == index + 1) ? listPayment.find(x => x.work_order_payment_type_id == index + 1).description  : '-'}}</td>
							</tr>
							
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="2">Loading.....</td>
							</tr>
						</tbody>
					</table>
					
				</div>
				<div class="col-md-6 col-12 mt-2">
					<h5>Catatan Tanggal Print Kwitansi</h5>
					<table class="table table-bordered">
						<thead class="thead-dark">
							<th>Nomor Kwitansi</th>
							<th>Waktu Print</th>
						</thead>
						<tbody v-for="row in historical" :key="row.unique_code">
							<td>{{row.unique_code}}</td>
							<td>{{moment(row.created_at).format('MMM DD, Y HH:mm')}}</td>
						</tbody>
					</table>
				</div>
			</div>

			<div class="row row-space mt-3 mb-3" v-if="dpList.length > 0">
				<div class="col-12">
					<h5>Catatan Down Payment</h5>
					<table class="table table-bordered">
						<thead class="thead-dark">
							<th>Deskripsi DP</th>
							<th>Tanggal DP</th>
							<th>Jumlah DP</th>
						</thead>
						<tbody v-for="dp in dpList" :key="dp.id">
							<td> {{ dp.description }}</td>
							<td>{{moment(dp.created_at).format('MMM DD, Y HH:mm')}}</td>
							<td>Rp. {{ numberWithCommas(dp.amount) }}</td>
						</tbody>
					</table>
				</div>
				
			</div>

			
			

			<!-- <div class="row row-space mt-3 mb-3">
				<div class="col-12">
					<h5>Biaya Lain Lainnya</h5>
				</div>
				
				<div class="col-md-6 col-8">
					<table class="table table-bordered" >
						<thead class="thead-dark">
							<th>Deskripsi</th>
							<th>Waktu Terbayar</th>
							<th>Harga</th>
							
						</thead>
						<tbody v-if="listPayment">
							<tr v-for="(payment, index) in extraCostList" :key="index">
								<td>{{payment.description}}</td>
								<td>{{moment(payment.created_at).format('MMM DD Y HH:mm')}}</td>
								<td>Rp. {{numberWithCommas(payment.amount)}}</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="2">Loading.....</td>
							</tr>
						</tbody>
					</table>
					
				</div>

				
			</div> -->
			<b-card class=" p-10">
				<div class="row">
					<div class="col-9 col-md-10">
						<h5>Biaya lain lainnya</h5>
					</div>
					<div class="col-3 col-md-2">
						<button class="btn btn-primary w-100" @click="form.extraCost.push(Object.assign({}, modelExtraCost))" :disabled="listPayment && listPayment.find(x => x.work_order_payment_type_id == 2)"> + Tambah Biaya</button>
					</div>
					<!-- <div class="col-3 col-md-2">
						<button class="btn btn-danger w-100" @click="form.extraCost.splice(-1,1)"> - Hapus Biaya</button>
					</div> -->
				</div>
				
				<hr>
				<div class="col-12" v-for="(formExtra, index) in form.extraCost" :key="index">
					
					<div class="row row-space mt-2" >
						<div class="col-md-1 col-6 middle">
							<h6>{{index + 1}}.</h6>
						</div>
						<div class="col-md-2 col-6 middle">
							<h6>Deskripsi :</h6>
						</div>
						<div class="col-md-3 col-6">
							<!-- <MultiSelect 
								:options="listOfBank.map(x => x.name)"
								
								v-model="form.bank_name"

							/> -->
							<input type="text" v-model="formExtra.description" class="form-control" />
						</div>
						<div class="col-md-2 offset-md-1 col-6 middle">
							<h6>Harga : </h6>
						</div>
						<div class="col-md-2 col-6 mt-auto mb-auto">
							<input type="text" v-model="formExtra.amount" class="form-control" />
						</div>
						<div class="col-md-1 col-6">
							<button class="btn btn-outline-danger" @click="form.extraCost.splice(index , 1)" :disabled="listPayment && listPayment.find(x => x.work_order_payment_type_id == 2)">
								<i class="fa fa-times" />
							</button>
						</div>
					</div>
					<hr>
				</div>
				<br>
				<div class="text-right">
					<button class="btn btn-info" @click="saveOtherCost"><i class="fa fa-save"/> Simpan ke System</button>
				</div>

				
			</b-card>

			<template v-if="paymentType">

			<h6 style="color:red" class="mt-4" v-if="listPayment && listPayment.find(x => x.work_order_payment_type_id == form.work_order_payment_type_id )">Pembayaran Untuk Work Order Tipe Ini Sudah Terbayar</h6>

			<div class="row row-space mb-2 mt-3" >
				<div class="col-4 mt-2">
					<h5 class="ml-1">Detail Harga Work Order :</h5>
				</div>
				<div class="offset-md-4 offset-2 col-md-2 col-4" >
					<button v-if="paymentType == 'Full'" class="btn btn-success w-100" :disabled="!woLog.find(x => x.log_id == 6) || woLog.find(x => x.log_id == 7)"  type="button" @click="showKirimModal = true">Kirim Kwitansi</button>
				</div>
				<!--  -->
				<div class="col-md-2 col-4">
					<button class="btn btn-info w-100" type="button" @click="showPrintModal()">Print Kwitansi</button>
				</div>
			</div>

			<h6 v-if="woLog.find(x => x.log_id == 7)"> Bukti Pengiriman Kwitansi : <button class="btn btn-success ml-3" style="background-color:#228B22" @click="modal.showImageModal = true">Liat Gambar</button></h6>
			<!-- <hr> -->
			<div class="row row-space p-10">
				<b-card no-body class="col-12 p-20">
					<template v-if="paymentType == 'Full'">
						<!-- {{woDetail}} -->
						<!-- <button v-if="woFull.customer_car" class="btn btn-info mb-2" @click="showCarInfo = !showCarInfo">{{showCarInfo ? 'Tutup' : 'Tampilkan'}} Informasi Mobil</button> -->
						<div class="mb-4">
							<table class="table table-bordered w-100" >
								<tbody class="thead-dark">
									<th colspan="4">Informasi Mobil</th>
								</tbody>
								<tbody>
									<th colspan="1">Nama Pelanggan</th>
									<td>{{woDetail.customer.name}}</td>
									<th colspan="1">No Polisi</th>
									<td>{{woDetail.nomor_polisi}}</td>
								</tbody>
								<tbody>
									<th colspan="1">Merek Tipe Mobil</th>
									<td>{{woDetail.tipe}}</td>
									<th colspan="1">No Rangka</th>
									<td>{{woDetail.nomor_rangka}}</td>
								</tbody>
								<tbody>
									<th colspan="1">Tahun</th>
									<td>{{woDetail.tahun}}</td>
									<th colspan="1">No Mesin</th>
									<td>{{woDetail.nomor_mesin}}</td>
								</tbody>
								<!-- <tbody>
									<th colspan="2"></th>
								</tbody> -->
							</table>
						</div>

						<!-- <div class="row mt-2">
							<div class="col-3">
								<h6>Total Part :</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(totalPart ?totalPart.toFixed(0) : 0)}}</h6>
							</div>
							<div class="col-3">
								<h6>Total Jasa :</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(totalJasa ? totalJasa.toFixed(0) : 0)}}</h6>
							</div>
						</div>

						<div class="row mt-2">
							<div class="col-3">
								<h6>Total Derek :</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(workOrderDetail.details.derek)}}</h6>
							</div>
							<div class="col-3">
								<h6>Total Own Risk :</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(workOrderDetail.details.own_risk)}}</h6>
							</div>
						</div>

						<div class="row mt-2">
							<div class="col-3">
								<h6>Total Discount Jasa :</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(workOrderDetail.details.discount ? workOrderDetail.details.discount : 0)}}</h6>
							</div>
							<div class="col-3">
								<h6>Total Discount Part :</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(workOrderDetail.details.discount_part ? workOrderDetail.details.discount_part : 0)}}</h6>
							</div>
							
						</div>

						<div class="row mt-2">
							<div class="col-3">
								<h6>PPh 23</h6>
							</div>
							<div class="col-3">
								<h6 v-if="typeof workOrderDetail.details.pph == 'number'">Rp. {{numberWithCommas(workOrderDetail.details.pph ? workOrderDetail.details.pph : 0)}} ({{100 - pphPercentage}}%)</h6>
							</div>
							<div class="col-3">
								<h6>Total PPN:</h6>
							</div>
							<div class="col-3">
								<h6>Rp. {{numberWithCommas(workOrderDetail.details.ppnTotal ? calculatePPN() : 0)}}</h6>
							</div>
							
						</div>
						<div class="row mt-2">
							<div class="col-3" v-if="dp">
								<h6>Down Payment</h6>
							</div>
							<div class="col-3" v-if="dp">
								<h6 >Rp. {{numberWithCommas(dp)}}</h6>
							</div>
						</div> -->
					</template>

					<!-- <div class="row mt-2">
						<div class="col-6">
							<h6>Total Tagihan Work Order :</h6>
						</div>
						<div class="col-6" v-if="form.work_order_payment_type_id <= 2">
							<h6>Rp. {{negative ? '-' : ''}}{{totalCost}}</h6>
						</div>
						<div class="col-6" v-else>
							<input type="text" class="form-control" v-model="totalCost" placeholder="Masukkan Jumlah DP WO" :disabled="listPayment.find(x => x.work_order_payment_type_id == 3)"/>
							<br>
							<span>Total Harga Yang Hrus Dibayar : Rp. {{outstandingSum}}</span>
						</div>
					</div> -->

					<h6 class="mt-3">Perincian Pembetulan Mobil</h6>
					<table class="table text-left">
						<thead>
							<th>No.</th>
							<th>Nama</th>
							<th>Deskripsi</th>
							<th>Jumlah</th>
							<th>Total</th>
							<th>Note</th>
						</thead>
						<tbody v-for="(estimation, index) in workOrderDetail.estimations" :key="index">
							<tr v-if="estimation.is_approved_by_insurance  == 1 && ((estimation.sparepart_type == 'P'  && !estimation.is_supplied_by_insurance )  || estimation.sparepart_type == 'J' || estimation.sparepart_type == 'O')">
								<td>{{index + 1}}</td>
								<td>{{estimation.sparepart_name}}</td>
								<td>{{estimation.part_number}}</td>
								<td>{{numberWithCommas(estimation.amount)}}</td>
								<td>{{estimation.price_per_item ? numberWithCommas(parseFloat(estimation.price_per_item) * parseFloat(estimation.amount)) : '-'}}</td>
								<!-- <td></td> -->
								<td>{{estimation.individual_ppn  ? `PPN : Rp. ${numberWithCommas(estimation.individual_ppn)}` : ''}}</td>
							</tr>
						</tbody>
					</table>
					
				</b-card>
			</div>

			<b-card no-body>
				<div
					class="row w-100 mt-4 ml-3 mr-3"
					v-if="workOrderDetail"
					style="font-size:14px;"
					:class="{ cancelled: woFull.deleted_at }"
				>
					
					<div
						class="col-12 mt-2"
					>
						<h4>Rincian Harga Work Order</h4>
						<table class="table wo-stats table-borderless" v-if="!mobile">
							<tr>
								<td>Total Jasa</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											this.workOrderDetail.details.totalJasa
										)
									}}
								</td>
								<td>Total Part</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											this.workOrderDetail.details.totalPart
										)
									}}
								</td>
							</tr>
							<tr>
								<td>Total Special Bahan</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											this.workOrderDetail.details.totalSpecialBahan
										)
									}}
								</td>
							</tr>
							<tr>
								<td>Diskon Jasa</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											this.workOrderDetail.details.discount
										)
									}}
								</td>
								<td>Diskon Part</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											this.workOrderDetail.details.discount_part
										)
									}}
								</td>
							</tr>
							<tr>
								<td>Total Discount</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											parseFloat(
												this.workOrderDetail.details.discount
											) +
												parseFloat(
													this.workOrderDetail.details
														.discount_part
												)
										)
									}}
								</td>
								<td>PPN
									<i class="fa fa-info-circle" id="averageTime"></i>
									<!-- <b-popover target="averageTime" title="Perincian Harga PPN" triggers="hover focus" placement="bottom" >

										<table class="table table-bordered text-center">
											<thead class="thead-dark">
												<th>Nama J / P</th>
												<th>Harga PPN</th>
											</thead>
											<tbody v-for="estimation in workOrderDetail.estimations">
												<tr>
													<td>{{estimation.alias}} - {{estimation.part_number}}</td>
													<td>{{
														estimation.without_ppn ? 
														'Harga Sudah Termasuk PPN' : 
														'Rp. ' + numberWithCommas(
															estimation.individual_ppn ? estimation.individual_ppn : 0
														)
													}}</td>
												</tr>
											</tbody>
										</table>
									</b-popover> -->

								</td>
								<td>:</td>
								<td>
									Rp. {{numberWithCommas(workOrderDetail.details.ppnTotal ? calculatePPN() : 0)}}
								</td>
								
							</tr>
							<tr style="font-weight:bold;border-bottom:1px solid black">
								<td colspan="3">Bruto Net Total</td>
								<td colspan="2"></td>
								<td>
									Rp
									{{
										numberWithCommas(
											parseFloat(
												this.workOrderDetail.details.totalJasa
											) +
											parseFloat(
												this.workOrderDetail.details.totalPart
											)+
											parseFloat(
												this.workOrderDetail.details.totalSpecialBahan
											)-
											parseFloat(
												this.workOrderDetail.details.discount
											) -
												parseFloat(
													this.workOrderDetail.details
														.discount_part
												)
											+ parseFloat(workOrderDetail.details.ppnTotal ? calculatePPN() : 0)
												
										)
									}}
								</td>
								<!-- <td>Total Discount Part</td>
								<td>:</td>
								<td>Rp {{numberWithCommas(this.workOrderDetail.details.totalPart * ( this.workOrderDetail.details.discount / 100))}} ({{this.workOrderDetail.details.discount}}%)</td> -->
							</tr>
							<tr>
								<td>Derek</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											parseFloat(
												this.workOrderDetail.details.derek
											)
										)
									}}
								</td>
								<td>PPh 23</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											parseFloat(this.workOrderDetail.details.pph)
										)
									}}
									({{ 100 - pphPercentage }}%)
								</td>
							</tr>
							<tr>
								<template v-if="paymentType !='OwnRisk'">
									<td>
										Own Risk
									</td>
									<td>:</td>
									<td>
										Rp
										{{
											numberWithCommas(
												parseFloat(
													this.workOrderDetail.details.own_risk
												)
											)
										}}
									</td>
								</template>
								<template v-else >
									<td style="background-color:yellow">
										<b>Own Risk</b>
									</td>
									<td style="background-color:yellow">:</td>
									<td style="font-weight:bold;background-color:yellow">
										Rp
										{{
											numberWithCommas(
												parseFloat(
													this.ownRiskCost
												)
											)
										}}
									</td>
								</template>
								<template v-if="dp">
									<td>Down Payment</td>
									<td>:</td>
									<td>
										Rp
										{{
											numberWithCommas(
												parseFloat(
													dp
												)
											)
										}}
									</td>
								</template>
								
							</tr>
							<tr v-if="workOrderDetail.tpl_cover" style="background-color:#6afc74">
								<td>TPL Coverage</td>
								<td>:</td>
								<td>
									Up to Rp. 
									{{
										numberWithCommas(
											parseFloat(
												this.workOrderDetail.tpl_cover.limit
											)
										)
									}}<br>({{this.workOrderDetail.tpl_cover.form_source}} - {{this.workOrderDetail.tpl_cover.nomor_polisi}})
								</td>
								<template v-if="fullPayment">
									<td>
										<b>Total Tercover Asuransi</b>
									</td>
									<td>:</td>
									<td>
										Rp
										{{
											numberWithCommas(
												parseFloat(
													fullPayment
												)
											)
										}}
									</td>
								</template>
							</tr>
							
						</table>

						
						
					</div>
					
				</div>
			</b-card>

			<div class="row row-space mt-3 pl-1 pr-1">

				<div class="col-md-4 col-6 middle" >
					<h6 class="middle">Tipe Pembayaran : </h6>
				</div>
				<div class="col-6 col-md-4">
					
					<MultiSelect
						class="w-100"
						v-model="form.payment_type_id"
						:options="formPayment.map(x => x.id)"
						:custom-label="opt => formPayment.find(x => x.id == opt).name"
						:searchable="true"
						:close-on-select="true"
						:multiple="false"
						:allow-empty="false"
						placeholder="Pilih Tipe Pembayaran"
					></MultiSelect>
				</div>
			</div>
			<div class="row row-space mt-2 pl-1 pr-1" v-if="!workOrderDetail.tpl_cover">
				<div class="col-md-4 col-6 middle">
					<h6>Diskon Work Order</h6>
				</div>
				<div class="col-md-4 col-6">
					<!-- <MultiSelect 
						:options="listOfBank.map(x => x.name)"
						
						v-model="form.bank_name"

					/> -->
					<input type="text" v-model="form.discount" class="form-control" />
				</div>
			</div>

			<div class="row row-space mt-2 pl-1 pr-1" v-if="workOrderDetail.tpl_cover && paymentType == 'Full'">
				<div class="col-md-4 col-6 middle">
					<h6>TPL Cover</h6>
				</div>
				<div class="col-md-4 col-6">
					<!-- <MultiSelect 
						:options="listOfBank.map(x => x.name)"
						
						v-model="form.bank_name"

					/> -->
					<input type="text" v-model="workOrderDetail.tpl_cover.value_paid" class="form-control" />
				</div>
			</div>

			

			

			<div class="mt-3 pl-1 pr-1" v-if="form.payment_type_id && form.payment_type_id < 4">
				
				<div class="row row-space mt-2">
					<div class="col-md-4 col-6 middle">
						<h6>Nama Bank :</h6>
					</div>
					<div class="col-md-4 col-6">
						<MultiSelect 
							:options="listOfBank.map(x => x.name)"
							
							v-model="form.bank_name"

						/>
					</div>
				</div>
				<div class="row row-space mt-2">
					<div class="col-md-4 col-6 middle">
						<h6>Nomor Rekening / 4 Digit Terkahir Kartu :</h6>
					</div>
					<div class="col-md-4 col-6">
						<input type="text" v-model="form.bank_account" class="form-control"/>
					</div>
				</div>
				<div class="row row-space mt-2">
					<div class="col-md-4 col-6 middle">
						<h6>Tanggal Pembayaran</h6>
					</div>
					<div class="col-md-4 col-6">
						<flat-pickr
							v-model="form.created_at"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>						
					</div>
				</div>
				<div class="row row-space mt-2" v-if="form.payment_type_id < 3">
					<div class="col-md-4 col-6 middle">
						<h6>Approval Code :</h6>
					</div>
					<div class="col-md-4 col-6">
						<input type="text" v-model="form.payment_approval_code" class="form-control" />
					</div>
				</div>
			</div>

			<h4 class="mt-3 mb-3 pl-1 pr-1">Net Pembayaran : Rp. {{calculateNet}}</h4>

			<div class="row row-space mt-3 pl-1 pr-1">
				<div class="col-12">
					<h6>Deskripsi :</h6>
					<textarea 
						rows="5"
						class="form-control w-100"
						v-model="form.description"
					/>
				</div>
			</div>

			<button
				type="button"
				class="btn btn-info mt-3 ml-1 "
				style="width:200px;"
				@click="submitForm()"
				:disabled="listPayment && listPayment.find(x => x.work_order_payment_type_id == form.work_order_payment_type_id )"
			>Selesai</button>

			

			



			</template>
		</div>

		<div class="row row-space mt-3" v-else>
			<div class="col-12 text-center">
				<h5>Tolong Dipilih Work Order Terlebih Dahulu Untuk Memulai Process Pembayaran</h5>
			</div>
		</div>

		<PrintKwitansi 
			v-if="showPrint"
			@closeModal="showPrint = false;getWoLog()"
			:form_code="workorder_id"
			:woDetail="woDetail"
			:data="workOrderDetail"
			:insuranceDetails="insuranceDetails"
			:discount="workOrderDetail.details.discount"
			:total="calculateNet"
			:insuranceCompany="insuranceCompany"
			:totalPart="totalPart"
			:tpl="workOrderDetail.tpl_cover ? true : false"
			:totalCost="totalCost"
			:totalSpecialBahan="workOrderDetail.details.totalSpecialBahan"
			:totalJasa='totalJasa'
			:paymentType="paymentType"
			:extraCost=" form.extraCost"
			:ppn="calculatePPNComputed"
			:dp="dp"
			
		/>

		<KirimKwitansi 
			v-if="showKirimModal"
			@closeModal="showKirimModal = false;getWoLog()"
			:form_code="workorder_id"
		/>

		<print-surat-puas
			v-if="modal.printSuratPuas"
			:form_code="workorder_id"
			@closeModal="modal.printSuratPuas = false"
		></print-surat-puas>

		<preview-image
			v-if="modal.showImageModal"
			@closeModal="modal.showImageModal = false"
			:title="'Bukti Pengriman'"
			:image="env.baseImage + '/' + woLog.find(x => x.log_id == 7).value"
		></preview-image>

		<adminAuth 
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			@token="showGatePass"
			:request="`Gatepass Before OR For ${workorder_id}__${woList.find(x => x.form_code == workorder_id).registration + ' - ' + woList.find(x => x.form_code == workorder_id).car_name  + ' - ' + woList.find(x => x.form_code == workorder_id).name}`"
			@approved="allowGatePass"
		/>

		<Reminder 
			v-if="modal.showReminder"
			@closeModal="modal.showReminder = false"
			:workorder="workorder_id"
			:total="calculateNet"
			@submitForm="modal.showReminder = false;submitForm(true)"
			:woProgress="woProgress"
			:listPayment="listPayment"
			:estimations="workOrderDetail.estimations.filter(x => x.sparepart_type == 'P')"
		/>

		<printEpoxy 
			v-if="modal.showEpoxyGambar"
			@closeModal="modal.showEpoxyGambar = false"
			:woProgress="woProgress"
		/>


	</div>
</template>

<script>
import MultiSelect from 'vue-multiselect'
import moment from 'moment'

import PrintKwitansi from './children/PrintKwitansi'
import KirimKwitansi from './children/kirimKwitansiModal'
import PrintEpoxy from './children/printEpoxy.vue'
import printSuratPuas from './children/woPaymentSuratPuas'
import previewImage from '@/components/modal/previewImage'
import adminAuth from '@/components/modal/adminAuthorization'
import Reminder from './children/Reminder.vue'
import env from '@/env'

export default {
	components : {
		MultiSelect,
		PrintKwitansi,
		KirimKwitansi,
		printSuratPuas,
		previewImage,
		adminAuth,
		Reminder,
		PrintEpoxy
	},
	data () {
		return {
			env, 
			extraCost : false,
			mobile : this.isMobile(),
			modal : {
				printSuratPuas : false,
				showImageModal : false,
				showAdminAuth : false,
				showReminder : false,
				showEpoxyGambar : false
			},
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL()
			},
			moment,
			paymentListType : ['Own Risk' , 'Pembayaran Full'],

			extraCostList : [],
			showPrint : false,
			showCarInfo : false,
			showKirimModal : false,
			insuranceCompany : null,
			insuranceDetails : null,
			woList : null,
			woLog : null,
			workorder_id : null,
			workOrderDetail : null,
			paymentType : null,
			totalCost : 0,
			ownRiskCost : 0,
			historical : null,
			woCost : 0,
			totalJasa : 0,
			totalPart : 0,
			woDetail : null,
			pphPercentage : null,
			formPayment : null,
			form : {
				"amount": null,
				"description": '',
				work_order_payment_type_id : 1,
				"payment_type_id": null,
				"transaction_type_id": 1,
				"bank_name": '',
				"bank_account": '',
				"payment_approval_code": '',
				tax : 0,
				discount : null,
				created_at : null,
				extraCost : [],
				// references_no : '',
				// payment_date : ''
			},
			modelExtraCost : {
				description : '',
				amount : null,
				transaction_type_id : 9,
				debit_credit : -1,
				work_order_payment_type_id : 4
			},
			listPayment : null,
			dp : 0,
			dpList : [],
			listOfBank : null,
			outstandingSum : 0,
			reason : '',
			negative : false,
			backButton : false,
			searchWo : true,
			returnPage : null,
			woProgress : null,
			woFull : null,
			fullPayment : null
		}
	},
	watch : {
		workorder_id : function () {
			this.$set(this , 'dp' , null)
			console.log('dp ' + this.dp)
			this.paymentType = null
			this.form.extraCost = []
			this.getWoOtherCost()
			this.getWoDetails()
			this.loadPaymentList ()
			this.getHistoricalCode()
			this.getWoLog()
			this.showPrintEpoxy(false)
			
		},
		extraCost : function () {
			if(this.form.extraCost.length == 0) {
				this.form.extraCost.push(Object.assign({} , this.modelExtraCost))
			}
		},
		totalCost : function () {
			
			const result = this.totalCost.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			
			this.$nextTick(() => this.totalCost = result);
		},
		'form.created_at' : function () {
			const result = moment(this.form.created_at).format('Y-MM-DD');
			this.$nextTick(() => this.form.created_at = result);
		},
		'form.discount' : function () {
			let result = null
			if(this.form.discount.includes('%')) {
				let percentageValue = parseInt(this.form.discount.split('%')[0])
				if(percentageValue > 100) {
					this.$store.dispatch('triggerAlert' , [false, 'Diskon persentase tidak bisa melebihi 100%'])
					this.$nextTick(() => this.form.discount = null);
					return
				}
				// console.log(parseFloat(this.totalCost.split(',').join('')) * (percentageValue / 100))

				result = (parseFloat(this.totalCost.split(',').join('')) * (percentageValue / 100)).toString().split('.')[0]

				
			}
			else {
				result = this.form.discount
			}

			result = result.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.discount = result);
		},
		'form.payment_type_id' : function () {
			if(this.form.payment_type_id  > 3) {
				this.form.bank_name = 'None'
				this.form.bank_account = 'None'
				this.form.payment_approval_code =  'None'
			}
			else if(this.form.payment_type_id == 3) {
				this.form.bank_name = ''
				this.form.bank_account = ''
				this.form.payment_approval_code =  'None'
			}
			else {
				this.form.bank_name = '',
				this.form.bank_account = '',
				this.form.payment_approval_code =  ''
			}

			this.$nextTick(() => this.totalCost = this.getTotalCostOptions());
		},
		paymentType : function () {
			console.log(this.paymentType)
			this.totalCost = this.getTotalCostOptions()
				
		},
		'workOrderDetail.tpl_cover.value_paid' : function () {
			if(!this.workOrderDetail.tpl_cover)
				return
			// if(this['workOrderDetail.tpl_cover.value_paid'] > this.wor)
			let currentLimit = parseFloat(this.workOrderDetail.tpl_cover.limit)
			let currentValue = parseFloat(this.workOrderDetail.tpl_cover.value_paid)

			if(currentValue > currentLimit) {
				// this['workOrderDetail.tpl_cover.value_paid'] = currentLimit
				this.workOrderDetail.tpl_cover.value_paid = currentLimit;
				this.$store.dispatch('triggerAlert' , [false , 'TPL Yang Tercover tidak boleh melewati limit yang di input.'])
			}
		}
	},
	mounted () {
		this.getListOfWorkOrder()
		this.getPaymentType()
		this.getListOfBank()
		

		if(this.$route.query.form_code) {
			this.workorder_id = this.$route.query.form_code
			// console.log(this.work_order_id)
			this.backButton = true
			this.searchWo = false
			this.returnPage = this.$route.query.from
		}
		
		
	},
	computed : {
		calculateNet() {
			return this.calculateNetMethod()
		},
		calculatePPNComputed () {
			return this.calculatePPN()
		},
		
		calculateTotalComputed () {
			let priceAfterDiscountJasa = this.totalJasa - parseFloat(this.workOrderDetail.details.discount)
			let priceAfterDiscountPart = this.totalPart - parseFloat(this.workOrderDetail.details.discount_part)
			let priceAfterDiscountBahan = parseFloat(this.workOrderDetail.details.totalSpecialBahan ? this.workOrderDetail.details.totalSpecialBahan : 0)
			console.log(this.workOrderDetail.details.totalSpecialBahan)
			let ppn =  (parseFloat(this.workOrderDetail.details.ppnTotal) )
			this.workOrderDetail.details.pph = ((100 - this.pphPercentage) / 100) * 0.02 * (priceAfterDiscountJasa) 
			this.workOrderDetail.details.totalAfterDisc = ((priceAfterDiscountJasa + priceAfterDiscountPart + priceAfterDiscountBahan)+ parseFloat(this.workOrderDetail.details.derek) - parseFloat(this.workOrderDetail.details.own_risk)) + ppn
			this.workOrderDetail.details = Object.assign({} , this.workOrderDetail.details)

			let total = this.workOrderDetail.details.totalAfterDisc  - this.workOrderDetail.details.pph


			let dp = this.listPayment.find(x => x.work_order_payment_type_id == 3)

			console.log(dp + 'lala')
			if(dp) {
				total = total - dp.amount
				this.dp = dp.amount
				console.log(total)
			}


			if(this.form.extraCost.length >= 1 ) {
				total = total -= this.sum(this.form.extraCost , 'amount')
			}
			

			return this.numberWithCommas(total.toFixed(0))
		}
	},
	methods : {
		calculateNetMethod () {
			let total = 0;

			if(this.workOrderDetail.tpl_cover && this.paymentType == 'Full') {
				// let limit = parseFloat(this.workOrderDetail.tpl_cover.value_paid)

				// total = Math.max(0 , total - limit)
				total = parseFloat(this.workOrderDetail.tpl_cover.value_paid ? this.workOrderDetail.tpl_cover.value_paid : 0)
			}
			else {
				let totalCost = this.totalCost ? parseFloat(this.totalCost.split(',').join('')) : 0
				this.negative ? totalCost = totalCost * - 1 : ''

				console.log(totalCost)
				

				let discount = this.form.discount ? parseFloat(this.form.discount.split(',').join('')) : 0

				if(this.paymentType == 'OwnRisk')
					return this.numberWithCommas(totalCost)
				
				let sumExtraCost = 0
				
				// if(th)
				for(var i = 0 ; i < this.form.extraCost.length ; i++) {
					sumExtraCost += parseFloat(this.form.extraCost[i].amount ? this.form.extraCost[i].amount : 0)
				}

				total = totalCost - discount - sumExtraCost
			}

			return this.numberWithCommas(total)
		},
		async showPrintEpoxy (flag) {
			try {
				let resp = await this.$http.get(`/api/v1/workorder/steps/${this.workorder_id}`)
				let data = Object.assign([] , resp.data.data.filter(x => x.step.id == 6 && x.status != -1));
				data = data.filter(x => x.estimations.length > 0 && (x.estimations[0].type == 'R/C' || x.estimations[0].type == 'Special Repair'))
				console.log(data)

				let woProgressList = {}

				for(var i = 0 ; i < data.length ; i++) {
					let curData = data[i]
					// if(curData.img)

					curData.name = `Epoxy #${curData.id} - ${curData.estimations[0].sparepart.sparepart_variants.name} ${curData.estimations[0].extension ? '- ' + curData.estimations[0].extension : ''}`
					woProgressList[curData.name] = curData.img ? curData.img : null
				}

				// console.log(woProgressList)

				this.woProgress = woProgressList

				if(flag)
					this.modal.showEpoxyGambar = true
			}
			catch(e) {
				console.log(e)
				this.$store.dispatch('triggerAlert' , [false , e , 'Something Went Wrong.'])
			}
		},
		getTotalCostOptions() {
			let totalCost = 0
			if(this.workOrderDetail.tpl_cover) {
				if(this.paymentType == 'OwnRisk') {
					if(!this.listPayment.find(x => x.work_order_payment_type_id == 2)) {
						this.$store.dispatch('triggerAlert' , [false , 'Mohon untuk mengisi Pembayaran Full Terlebih Dahulu.'])
						this.form.work_order_payment_type_id = 2
						this.paymentType = 'Full'
						return
					}
					this.form.work_order_payment_type_id = 1
					totalCost = this.numberWithCommas(this.ownRiskCost)

				}
				else if (this.paymentType == 'Full') {
					this.form.work_order_payment_type_id = 2
					totalCost = this.calculateNetMethod()
				}
			}
			else if(this.paymentType == 'OwnRisk'){
				totalCost = this.numberWithCommas(this.ownRiskCost)
				this.form.work_order_payment_type_id = 1 
			}
				
			else if(this.paymentType == 'Full'){
				totalCost = this.calculateTotal()
				this.form.work_order_payment_type_id = 2
			}
			// else {
			// 	this.form.work_order_payment_type_id = 3
			// 	let findPayment = this.listPayment.find(x => x.work_order_payment_type_id == 3)
			// 	totalCost = findPayment ? `${parseFloat(findPayment.amount)}` : 0
			// 	this.outstandingSum = this.calculateTotal()
			// }

			return totalCost
		},
		returnToPage () {
			this.$router.push({name : this.returnPage , params : {id : this.workorder_id}})
		},
		getHistoricalCode () {
			this.$http.get('/api/v1/workorder/print/historical?form_code=' + this.workorder_id)
			.then((resp) => {
				this.historical = resp.data.data
				
			})
			.catch((err)=> {
				console.log(err)
			})
		},
		calculatePPN (){
        	let ppn = parseFloat(this.workOrderDetail.details.ppnTotal ? this.workOrderDetail.details.ppnTotal : 0)
			return ppn
		},
		saveOtherCost () {

			if(this.listPayment.find(x => x.work_order_payment_type_id == 2)) {
				this.$store.dispatch('triggerAlert' , [false , 'Unable to save Extra Cost. Work Order has been fully paid.'])
				return
			}

			// if(this.form.ex)
			let descriptionEmpty = this.form.extraCost.filter(x => x.description == '')
			if(descriptionEmpty.length > 0) {
				this.$store.dispatch('triggerAlert' , [false , 'Deskripsi Tidak Boleh kosong'])
				return
			}

			let priceEmpty = this.form.extraCost.filter(x => !x.amount)
			if(priceEmpty.length > 0) {
				this.$store.dispatch('triggerAlert' , [false , 'Harga Tidak Boleh kosong'])
				return
			}



			this.$http.post('/api/v1/workorder-estimation/' + this.workorder_id + '/other-cost' , this.form.extraCost)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Biaya Lain Lainnya Berhasil Tersimpan.'])
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getWoOtherCost () {
			this.$http.get('/api/v1/workorder-estimation/' + this.workorder_id + '/other-cost')
			.then((resp) => {
				let data = resp.data.data
				for(var i = 0 ; i < data.length ; i++) {
					let model = JSON.parse(JSON.stringify(this.modelExtraCost))
					model.description = data[i].description
					model.amount = data[i].price
					model.id = data[i].id
					this.form.extraCost.push(model)
				}

				
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
		showGatePass(token = null) {
			if (this.listPayment && this.listPayment.find(x => x.work_order_payment_type_id == 1 )) {
				this.$router.push({ path:'/cso/exit-permit', query : { form_code : this.workorder_id } })
				return;
			}

			let prevToken = ''

			if(token) {
				prevToken = this.$http.defaults.headers.common['Authorization']

				this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
			}

			this.$http.get('/api/v1/check')
			.then((resp) => {
				let data = resp.data.data
				let super_user = data.is_superuser

				if(super_user) {
					this.allowGatePass(token , prevToken)
				}
				else {
					
					this.modal.showAdminAuth = true
					this.reason = token ? 'Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya.' :'Untuk Memakai Fitur Gatepass, Diperlukan untuk menerbitkan pembayaran Own Risk terlebih dahulu'

				}
			})
			.catch((err) => {
				console.log(err)
			})
			// 
		},
		allowGatePass(token , prevToken) {
			this.modal.showAdminAuth = false
			this.$store.dispatch('triggerAlert' , [true , 'Admin Permission Success'])
			if(token)
				this.$http.defaults.headers.common['Authorization'] = prevToken


			this.$router.push({ path:'/cso/exit-permit', query : { form_code : this.workorder_id } })
		},
		sendToGatePass() {
			this.$router.push({ path:'/cso/exit-permit', query : { form_code : this.workorder_id } })
		},
		getWoLog() {
			this.$http.get('/api/v1/workorder/log/' + this.workorder_id)
			.then((resp)=> {
				this.woLog = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getListOfBank() {
			// /api/v1/masterData/bank
			this.$http.get('/api/v1/masterData/bank')
			.then((resp) => {
				this.listOfBank = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		showPrintModal() {
			if(!this.totalCost) {
				this.$store.dispatch('triggerAlert' , [false , 'Total Harga Tidak Boleh Kosong.'])
				return
			}
			// this.$store.dispatch('triggerAlert' , [true , this.totalCost])
			let amount = parseInt(this.totalCost.split(',').join(''))
			if(amount <= 0 && this.paymentType != 'OwnRisk' ) this.$store.dispatch('triggerAlert' , [false , 'Total Harga Tidak Boleh 0 atau dibawah.'])
			else 
				this.showPrint = true;
		},
		loadPaymentList () {

			
			this.$http.get('/api/v1/workorder-estimation/'+ this.workorder_id +'/receipt')
			.then((resp) => {
				this.listPayment = resp.data.data
				

				let dpList = this.listPayment.filter(x => x.work_order_payment_type_id == 3)

				let dpTotal = 0

				for(var i = 0 ; i < dpList.length ; i++) {
					dpTotal += parseFloat(dpList[i].amount)
				}

				this.dp = dpTotal
				this.dpList = dpList

				this.extraCostList = resp.data.data.filter(x => x.work_order_payment_type_id == 4)
			})
			.catch((err) => {
				console.log(err.response , err)
				let array = err.response.data.data.details.map(x => x.message)
				this.$store.dispatch('triggerAlert' , [false , array])
			})
		},
		sum(arr , variable) {
			let newArr = arr.map(x => x[variable])
			let total = 0
			for(var i = 0 ; i < newArr.length ; i++) {
				total+= parseFloat(newArr[i])
				arr[variable] = parseFloat(arr[variable])
			}

			return total
		},
		submitForm(reminder = false) {
			if(this.paymentType == 'Full' && !reminder) {
				this.modal.showReminder = true
				return
			}

			let bodyData = JSON.parse(JSON.stringify(this.form))

			let totalCost = this.getTotalCostOptions()
			bodyData.amount = parseFloat(totalCost.split(',').join("")) ? parseFloat(totalCost.split(',').join("")) : 0

			if(bodyData.discount){
				bodyData.discount = parseFloat(bodyData.discount.split(',').join(''))
				bodyData.amount = bodyData.amount - bodyData.discount
			} else {
				bodyData.discount = 0
			}

			if(bodyData.work_order_payment_type_id == 2) {
				if(bodyData.extraCost.length > 0) {
					bodyData.amount = bodyData.amount - this.sum(bodyData.extraCost, 'amount')
					for(var i = 0 ; i < bodyData.extraCost.length ;i++) {
						delete bodyData.extraCost[i].id
						bodyData.extraCost[i].amount = parseFloat(bodyData.extraCost[i].amount)
					}
				}
			}
			
			if(bodyData.work_order_payment_type_id == 3 && bodyData.amount > parseFloat(this.calculateTotal().split(',').join(''))) {
				this.$store.dispatch('triggerAlert' , [false , 'Harga Dp tidak bisa melebihi jumlah penagihan Work Order'])
				return
			}
			this.$http.post('/api/v1/workorder-estimation/' + this.workorder_id + '/payment' , bodyData)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Pembayaran Berhasil Disimpan'])
				this.loadPaymentList()
				this.getWoDetails()
			})
			.catch((err) => {
				console.log(err.response)
				let array = err.response.data.data.details.map(x => x.message)
				this.$store.dispatch('triggerAlert' , [false , array])
			})
		},
		getPaymentType () {
			this.$http.get('/api/v1/masterData/payment-type?pagination=false')
			.then((resp) => {
				this.formPayment = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		calculateTotal () {
			let priceAfterDiscountJasa = this.totalJasa - parseFloat(this.workOrderDetail.details.discount)
			let priceAfterDiscountPart = this.totalPart - parseFloat(this.workOrderDetail.details.discount_part)
			let priceAfterDiscountBahan = parseFloat(this.workOrderDetail.details.totalSpecialBahan ? this.workOrderDetail.details.totalSpecialBahan : 0)
			// console.log(this.workOrderDetail.details.totalSpecialBahan)
			let ppn = parseFloat(this.workOrderDetail.details.ppnTotal)
			this.workOrderDetail.details.pph = ((100 - this.pphPercentage) / 100) * 0.02 * (priceAfterDiscountJasa) 
			this.workOrderDetail.details.totalAfterDisc = ((priceAfterDiscountJasa + priceAfterDiscountPart + priceAfterDiscountBahan)+ parseFloat(this.workOrderDetail.details.derek) - parseFloat(this.workOrderDetail.details.own_risk)) + ppn
			
			this.workOrderDetail.details = Object.assign({} , this.workOrderDetail.details)

			let total = this.workOrderDetail.details.totalAfterDisc  - this.workOrderDetail.details.pph

			console.log(total)
			// let dp = this.listPayment.find(x => x.work_order_payment_type_id == 3)
			// let dp = this.dp
			total = total - this.dp

			// console.log(dp.amount + 'lala')
			// if(dp) {
			// 	total = total - this.dp
			// 	this.dp = dp.amount
			// 	console.log(total)
			// }
			// else {
			// 	this.dp = null
			// }

			total > 0 ? this.negative = false : this.negative = true

			return this.numberWithCommas(total.toFixed(0))
		},
		getListOfWorkOrder () {
			this.woList = null;

			this.$http.get('/api/v1/workorder/listing/done-workorder?pagination=false')
			.then((resp) => {
				this.woList = resp.data.data
				// console.log(this.woList)
			})
			.catch((err) => { console.log(err) })
		},

		getWoDetails(){
			this.$http.get(`/api/v1/workorder/${this.workorder_id}/detail`)
			.then(async (resp)=>{
				var data = resp.data.data;

				let carDetail = null

				if(data.customer_car)
					carDetail = this.$store.getters.getModelDetailById(data.customer_car.car_id)

				this.woDetail = {
					customer: data.customer,
					car : data.customer_car ? data.customer_car : {},
					work_order_id : this.form_code,
					nomor_mesin : data.customer_car ? data.customer_car.engine_number : data.engine_number ? data.engine_number : '-',
					nomor_rangka : data.customer_car ? data.customer_car.chassis_number : data.chassis_number ? data.chassis_number : '-',
					nomor_polisi : data.customer_car ? data.customer_car.registration : data.registration ? data.registration : '-',
					asuransi : data.customer_car ? data.customer_car.insurance : '-',
					// kerusakan : this.evaluateDamage(data.condition.figure),
					tanggal_masuk : moment(data.created_at).format('DD MMM YY HH:mm'),
					pelanggan : data.customer ? data.customer.name : '-',
					cso : data.CSO,
					merek : data.customer_car ? carDetail.brand_name : data.brand ? data.brand.name : '-',
					tipe : data.customer_car ? carDetail.name : data.model? data.model.name : '-',
					// image : data.condition.figureOverall.front.image,
					address : data.customer.address,
					warna: data.customer_car ? data.customer_car.car_color.name : data.colour? data.colour.name : '-',
					tahun : data.customer_car ? data.customer_car.year : data.year? data.year : '-',
					car_id : data.customer_car ? data.customer_car.car.brand_id : null,
					car_name : data.customer_car ? data.customer_car.car.name.split(" ")[0] : data.model? data.model.name : '-',
					// spk_documents : spk,
					price : data.customer_car ? data.customer_car.price : 0
				}

				this.woFull = data

			})
			.then(()=>{
				this.getPaymentWorkOrder()
			})
			.catch((err)=>{console.log(err)})
		},
		async getPurchaseOrderDetails() {
			let result = await this.$http.get(
				"/api/v1/purchase-order/" + this.workorder_id
			);

			return result.data.data;
		},
		getPaymentWorkOrder () {

			this.totalJasa = 0
			this.totalPart = 0
			this.totalCost = 0
			this.woCost = 0
			this.ownRiskCost  = 0 

			this.$http.get('/api/v1/workorder-estimation/' + this.workorder_id)
			.then(async (resp) => {
				this.workOrderDetail = resp.data.data

				let estimations = this.workOrderDetail.estimations
				let ppnPercentage = this.workOrderDetail.ppn
				this.ownRiskCost = parseFloat(this.workOrderDetail.details.own_risk)
				let listOfPO = await this.getPurchaseOrderDetails();
				this.form.amount = this.ownRiskCost
				// console.log(this.ownRiskCost)
				this.totalCost = this.numberWithCommas(this.ownRiskCost)
				
				let ppnTotal = 0
				// console.log(this.woDetail.asuransi , this.workOrderDetail.details.insurance_id)
				if(this.workOrderDetail.details.insurance_id) {
					this.insuranceDetails = this.woDetail.asuransi.find(x=> x.id == this.workOrderDetail.details.insurance_id)
					this.workOrderDetail.details.insurance_company_id = this.insuranceDetails.insurance_company
					this.getPPhPercentage(this.workOrderDetail.details.insurance_company_id)
				}
				else {
					this.pphPercentage = 100.00
				}
				

				let derekList = this.workOrderDetail.details.derekData.map(x => parseFloat(x.amount))
					
				const reducer = (accumulator, curr) => accumulator + curr;

				this.workOrderDetail.details.derek = derekList.length > 0 ? derekList.reduce(reducer) : 0


				this.totalJasa = this.workOrderDetail.details.totalJasa
				this.totalPart = this.workOrderDetail.details.totalPart

				let discountMultJasa = parseFloat(this.workOrderDetail.details.discount) / this.totalJasa
				let discountMultPart = parseFloat(this.workOrderDetail.details.discount_part) / this.totalPart

				let discountPPN = parseFloat(this.workOrderDetail.details.discount) + parseFloat(this.workOrderDetail.details.discount_part)
				

				for(var i = 0 ; i < estimations.length ; i++) {
					if(!estimations[i].price_per_item) estimations[i].price_per_item = 0;

					if(!estimations[i].is_approved_by_insurance) continue
					let discountMult = estimations[i].sparepart_type == 'J' ? discountMultJasa : discountMultPart
					let deductible = (parseFloat(estimations[i].price_per_item) * parseFloat(estimations[i].amount) * discountMult)

					estimations[i].price_per_item = estimations[i].price_per_item ? estimations[i].price_per_item : 0
					estimations[i].markup = estimations[i].markup ? estimations[i].markup : 0

					estimations[i].price_per_item = parseFloat(estimations[i].price_per_item) +  parseFloat(estimations[i].markup)
					if (estimations[i].sparepart_type == "P") {
						let poDetails = listOfPO.find(
							(x) =>
								x.estimation_id == estimations[i].id &&
								!x.next_purchase_order_item
						);
						// console.log(poDetails)
						if (poDetails) {
							estimations[i].is_po = true;
							estimations[i].is_used = poDetails.is_used;
							estimations[i].is_arrived =
								poDetails.is_arrived;
							estimations[i].time =
								poDetails.time_of_arrival;

							estimations[i].is_used_date = poDetails.is_used_date
						} else {
							estimations[i].is_po = false;
						}
					}



					this.woCost += (parseFloat(estimations[i].amount) * (parseFloat(estimations[i].price_per_item)))
					// console.log(estimations[i])

					// if(estimations[i].is_approved_by_insurance == 1 && !estimations[i].is_supplied_by_insurance) {
					let ppn = estimations[i].ppn_included
					let without_ppn = estimations[i].without_ppn

					// let discountMult = estimations[i].sparepart_type == 'J' ? discountMultJasa : discountMultPart

					

					estimations[i].price_per_item = parseFloat(estimations[i].price_per_item)

					// console.log(estimations[i])

					if (ppn == 1 && !without_ppn && estimations[i].sparepart_type == 'J') {
						estimations[i].price_per_item = parseFloat(
							estimations[i].price_per_item / (1 + ppnPercentage)
						);

						estimations[i].individual_ppn = (parseFloat(estimations[i].price_per_item) *
								parseFloat(estimations[i].amount) - deductible) *
								ppnPercentage;

						ppnTotal += estimations[i].individual_ppn
					}
					else if (estimations[i].sparepart_type == 'J' && ppn == 0 && !without_ppn) {
						estimations[i].individual_ppn = (parseFloat(estimations[i].price_per_item) *
								parseFloat(estimations[i].amount) - deductible) *
								ppnPercentage;
						ppnTotal +=  estimations[i].individual_ppn

					}

					if(estimations[i].ppn) {
							
						estimations[i].individual_ppn = (estimations[i].price_per_item )* (1 - discountMult) * ppnPercentage
						// console.log(estimationList[i].individual_ppn)

						ppnTotal +=  estimations[i].individual_ppn * parseFloat(estimations[i].amount)
					}

					if(without_ppn) {
						discountPPN = discountPPN - (parseFloat(estimations[i].price_per_item) * parseFloat(estimations[i].amount) * discountMult)
					}
				}

				console.log(ppnTotal , this.workOrderDetail.details.discount + this.workOrderDetail.details.discount_part)
				if(ppnTotal != 0) ppnTotal = Math.max( 0 , ppnTotal)
				// console.log(ppnTotal)
				this.workOrderDetail.details.ppnTotal = ppnTotal ? ppnTotal : 0

				this.$set(this.workOrderDetail , 'tpl_cover' , await this.getTPL())

				if(this.workOrderDetail.tpl_cover) {
					let fullPayment = this.listPayment.find(x => x.work_order_payment_type_id == 2)
					// console.log(fullPayment)
					if(fullPayment) {
						fullPayment = parseFloat(fullPayment.amount)
						this.fullPayment = fullPayment
						// console.log(this.calculateTotal() + ' TPL_Cover ' + fullPayment)
						this.ownRiskCost = parseFloat(this.calculateTotal().split(',').join('')) - fullPayment
					}
					
				}
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
		async getTPL () {
			try {
				let response = await this.$http.get('/api/v1/insurance/tpl/existing?form_destination=' + this.workorder_id)
				// console.log(response)

				let data = response.data.data[0]
				if(data) {
					this.$set(data , 'value_paid' , data.limit)
				
					return data
				}
				else 
					return null
				
			}
			catch (e) {
				console.log(e)
			}
		},
		getPPhPercentage (id) {
			this.$http.get('/api/v1/insurance/company/' + id)
			.then((resp) => {
				let data = resp.data.data
				this.insuranceCompany = data
				// console.log(this.insuranceCompany)
				this.pphPercentage = data.pph_insurance
				this.calculateTotal()
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
	}
}
</script>

<style scoped>
	.middle {
		margin-top: auto ; 
		margin-bottom : auto;
	}
</style>